exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_sortableItem__1BSoO{border:.0625rem solid #ccc;padding:.5rem 1rem;margin-bottom:.5rem;background-color:hsla(0,0%,60%,.08);cursor:move;color:#000}.style_name__-RgrS{padding-left:1rem}", ""]);

// exports
exports.locals = {
	"sortableItem": "style_sortableItem__1BSoO",
	"name": "style_name__-RgrS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/SortableList/style.less
// module id = 1903
// module chunks = 8